<template>
    <center v-if="idat">
		<div class="football-field">
			<span v-for="flabel in idat.labels" v-bind:key="flabel.label" v-bind:style="'position: absolute; -webkit-text-stroke: 0.5px white; font-weight: bold; text-align: center; font-size: 1.7em; top: ' + flabel.position.x + 'px; left: ' + flabel.position.y + 'px; color: ' + flabel.color">{{flabel.label}}</span>
			<Infographic5Position v-for="(mark, i) in idat.markers"
				v-bind:ID="i"
				v-bind:key="i"
				v-bind:position="mark.position"
				v-bind:label="mark.label"
				v-bind:description="mark.description"
				v-bind:color="mark.color"
				/>
		</div>
	</center>
</template>
<script>
import { ajaxGet, ajaxPost } from "../../../ajax";
import Infographic5Position from './Infographic5Position'
import {apiUrl} from "@/main";

export default {
	components: { Infographic5Position },
    data: function() {
        return {
        	idat: undefined,
        	infoId: undefined
		}
	},
	created(){
		this.infoId = this.$router.history.current.params.infoId;
            var assignmentFlag = (this.$router.history.current.query.Assignment === null) ? 'assignments' : 'content';
            ajaxGet(apiUrl()+"/"+assignmentFlag+"/" + this.infoId,
			(dat) => {
				//on success dat is called
				if(dat.component == "infographic5"){
					//This is the right component
					this.idat = dat.data;
					// console.log(this.idat);
					this.isAnswered = dat.answers;
                	window.document.title = dat.title
                    //----------------------------------------------------------
                    if(this.$router.history.current.query.Assignment === null && !this.isAnswered){
                        ajaxPost(apiUrl() +"/assignments/" + this.infoId, {
                        Data: {
                            seen: Date.now()
                        }
                    },
                    (suc) => {
                        console.log("Posted assignment:", suc);
                    },
                    (err) => {
                        console.log("Error :", err)
                    }, localStorage.token);
                    }
                    //----------------------------------------------------------
				}else{
					//Wrong component type
					console.error("DATA MISMATCH on api call expected 'infographic5' object, got '" + dat.component.toUpperCase() + "' object.");
				}
			},(err) => {
				//There was some error
				console.log(err);
			}, localStorage.token);
	}
}
</script>

<style scoped>
	.football-field{
		position: relative;
		top: 55px;
		width: 800px;
		height: 600px;
		max-width: 800px;
		max-height: 600px;
		overflow: auto;
		display:flex;
		align-items: center;
		flex-direction: column;
		background: #006e2e; /* Old browsers */
		background: -moz-linear-gradient(45deg, #006e2e 0%, #00541c 56%, #00260d 100%); /* FF3.6-15 */
		background: -webkit-linear-gradient(45deg, #006e2e 0%,#00541c 56%,#00260d 100%); /* Chrome10-25,Safari5.1-6 */
		background: linear-gradient(45deg, #006e2e 0%,#00541c 56%,#00260d 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
		filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#006e2e', endColorstr='#00260d',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */
	}
</style>